import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from "./services/auth.guard";
import { RoleGuard } from "./services/role.guard";

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    canActivate: [AuthGuard],

    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },

  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },

  {
    path: 'cirrus-admin',
    canActivate: [RoleGuard],
    data: {
      minRole: 1000
    },
    loadChildren: () => import('./pages/cirrus-admin/cirrus-admin.module').then( m => m.CirrusAdminPageModule)
  },
  {
    path: 'client-admin/:client',
    canActivate: [RoleGuard],
    data: {
      minRole: 1
    },
    loadChildren: () => import('./pages/client-admin/client-admin.module').then( m => m.ClientAdminPageModule)
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/dashboard/dashboard.module').then( m => m.DashboardPageModule)
  },
  {
    path: 'sector/:client/:sid/edit',
    canActivate: [RoleGuard],
    data: {
      minRole: 100
    },
    loadChildren: () => import('./pages/sector-edit/sector-edit.module').then( m => m.SectorEditPageModule)
  },
  {
    path: 'sector/:client/:sid/manage',
    canActivate: [RoleGuard],
    data: {
      minRole: 100
    },
    loadChildren: () => import('./pages/sector-manage/sector-manage.module').then( m => m.SectorManagePageModule)
  },
  {
    path: 'sector/:client/:sid/vis',
    canActivate: [RoleGuard],
    data: {
      minRole: 1
    },
    loadChildren: () => import('./pages/sector-vis/sector-vis.module').then( m => m.SectorVisPageModule)
  },
  {
    path: 'sector/:client/:sid/map',
    canActivate: [RoleGuard],
    data: {
      minRole: 1
    },
    loadChildren: () => import('./pages/sector-map/sector-map.module').then( m => m.SectorMapPageModule)
  },
  {
    path: 'sector/:client/:sid/delete',
    canActivate: [RoleGuard],
    data: {
      minRole: 100
    },
    loadChildren: () => import('./pages/sector-delete/sector-delete.module').then( m => m.SectorDeletePageModule)
  },
  {
    path: 'conflicts/:client',
    canActivate: [RoleGuard],
    data: {
      minRole: 100
    },
    loadChildren: () => import('./pages/conflicts/conflicts.module').then( m => m.ConflictsPageModule)
  },
  {
    path: 'reports/:client',
    canActivate: [RoleGuard],
    data: {
      minRole: 100
    },
    loadChildren: () => import('./pages/reports/reports.module').then( m => m.ReportsPageModule)
  },
  {
    path: 'report-cell-editor',
    loadChildren: () => import('./pages/report-cell-editor/report-cell-editor.module').then( m => m.ReportCellEditorPageModule)
  }
  // },
  // {
  //   path: 'conflict-mediator',
  //   loadChildren: () => import('./pages/conflict-mediator/conflict-mediator.module').then( m => m.ConflictMediatorPageModule)
  // }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
